import {getLclStorage} from '@/utils/localstorage'

export default function Home() {
  const device = getLclStorage('_syspf', {type: 2})
  let w: any = window
  if (device === 'desktop') {
    w.location = '/login-page'
  }
  return <></>
}
